import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { Button, Tab, Tabs, Typography } from '~/UIKit';
import { ItemCreationToolbarStyles } from './ItemCreationToolbarStyles';
import classNames from 'classnames';
import { IItemCreationHeader } from '../';

interface IItemCreationToolbarProps {
  isLoading?: boolean;
  activeSectionIndex: number;
  setActiveSectionIndex: (index: number) => void;
  headers: IItemCreationHeader[];
  disableMobile?: boolean;
}

export const ItemCreationToolbar = ({
  isLoading,
  activeSectionIndex,
  headers,
  setActiveSectionIndex,
  disableMobile,
}: IItemCreationToolbarProps) => {
  const { classes } = ItemCreationToolbarStyles();

  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));
  const mobile = mobileView && !disableMobile;

  const handleChange = (_e: React.ChangeEvent<{}>, index: number) => setActiveSectionIndex(index);
  const headerButtonOnClick = (header: IItemCreationHeader) => () =>
    setActiveSectionIndex(header.index);

  return mobile ? (
    <div
      className={classNames(
        classes.ItemCreationToolbarContainer,
        classes.ItemCreationToolbarMobile,
      )}
    >
      {headers.map((header) => (
        <Button
          className={classNames(classes.ItemCreationToolbarSection, {
            active: activeSectionIndex === header.index,
          })}
          key={`nav_${header.title}_${header.index}`}
          onClick={headerButtonOnClick(header)}
          disabled={isLoading}
          data-testid={header.testId}
        >
          {header.icon}
          <Typography
            className={classNames(
              classes.ItemCreationToolbarSectionTitle,
              classes.ItemCreationToolbarSectionTitleMobile,
            )}
          >
            {`${header.title} `}
            {header.isDone && (
              <CheckCircle
                data-testid="checkmark"
                className={classes.ItemCreationToolbarSectionCheckMark}
              />
            )}
          </Typography>
        </Button>
      ))}
    </div>
  ) : (
    <Tabs
      className={classes.ItemCreationToolbarContainer}
      value={activeSectionIndex}
      onChange={handleChange}
      variant={mobileView ? 'fullWidth' : 'standard'}
    >
      {headers.map((header) => (
        <Tab
          key={`nav_${header.title}_${header.index}`}
          disabled={isLoading}
          data-testid={header.testId}
          label={
            <span>
              {`${header.title} `}
              {header.isDone && (
                <CheckCircle
                  viewBox="0 0 50 50"
                  data-testid="checkmark"
                  className={classes.ItemCreationToolbarSectionCheckMark}
                />
              )}
            </span>
          }
          value={header.index}
        />
      ))}
    </Tabs>
  );
};
